import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";

const createUploadGrant = new SchemaValidator(
	Type.Object({
		id: Type.String(),
		url: Type.String(),
	}),
);

const getLinks = new SchemaValidator(
	Type.Array(
		Type.Object({
			id: Type.String(),
			url: Type.String(),
			uploadedAt: Type.Optional(Type.Number()),
		}),
	),
);

export default {
	createUploadGrant,
	getLinks,
};
